export class Login {
    UserName: string = '';
    Password: string = '';
    EmailID : string ='';
   staySignedIn?: boolean = false;
  }
// Login response data class
export class Profile {
  myName: string = '';
  Role: string = '';
  ForceChangePassword: boolean=false;
  AgentStatus: string = '';
  ForceConfirmInfo: boolean= false;
  FirstName: string = '';
  LastName: string = '';
  AgencyCode: string = '';
  IsPCICompliant: boolean= false;
  AllowMbrEnrollment: boolean = false;
}
export class Organization {
  perimeters: any;
  getId() {
    throw new Error('Method not implemented.');
  }
  id?: string;
  name?: string;
  type?: string;
  parentId?: string;
  children?: Organization[];
  users?: string[];
  admins?: string[];
  settings?: Record<string, any>;
  createdAt?: Date;
  updatedAt?: Date;
  contacts: string[] = [];
  safezones?: any[];
  perimeterIds?: string[];
  facilities?: any[];
  sops?: any[];
  orgData?: any;
  ancestors?: string[];
  descendants?: string[];
  multi?: boolean;
  geofences?: any[];
  label?: string;
  entityLocations: any[] = [];
 
  
  getEntityLocations() {
    return this.entityLocations;
  }
  
  setEntityLocations(entityLocations: any[]) {
    this.entityLocations = entityLocations;
  }
}
  
  export class PluginObject {
    pluginName: string = '';
    displayName: string = '';
    pluginPath: string = '';
  
    constructor(pluginName: string, displayName: string, pluginPath: string) {
      this.pluginName = pluginName;
      this.displayName = displayName;
      this.pluginPath = pluginPath;
    }
  }
export interface Facility {
  attributes: any;
  id: string;
  label: string;
  organizationId: string;
  buildingId?: string;
  coordinates: [number, number];
  address?: string;
}
export class OrgOption {
  constructor(public name: string, public orgId: string) {}
  getId() { return this.orgId; }
  getTitle() { return this.name; }
  private events: any[] = [];
  setEvents(events: any[]) {
    this.events = events.filter(e => e.organizationId === this.orgId); // or whatever matches your org
  }
  getEvents() {
    return this.events;
  }
}